var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.591 5.78033C14.8839 5.48744 14.8839 5.01256 14.591 4.71967C14.2981 4.42678 13.8232 4.42678 13.5303 4.71967L6 12.25L13.5303 19.7803C13.8232 20.0732 14.2981 20.0732 14.591 19.7803C14.8839 19.4874 14.8839 19.0126 14.591 18.7197L8.12132 12.25L14.591 5.78033Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronleft);
export default __webpack_public_path__ + "static/media/Chevron left.f819477674cc2a968b804c7b3b417a62.svg";
export { ForwardRef as ReactComponent };